import PropTypes from "prop-types";
import React, { Component } from 'react';
import {Translate} from "react-localize-redux";
import {Label, Input, FormGroup, Form, Button, FormFeedback, Alert, Row, Col} from "reactstrap";
import {isEmptyString} from "../../../../utils/string-utils";
import {audioDevicePropTypes} from "../../../../utils/models-prop-types";
import {Formik} from "formik";
import VolumeSlider from "./volume-slider";

const propTypes = {
  config: PropTypes.shape({
    autoStart: PropTypes.bool,
    sipRtpPortStart: PropTypes.number,
    sipRtpPortRange: PropTypes.number,
    inputDevice: PropTypes.string,
    inputMode: PropTypes.string,
    inputVolume: PropTypes.string,
    outputDevice: PropTypes.string,
    outputVolume: PropTypes.string,
    playbackFramesPerPacket: PropTypes.number
  }),
  forbiddenUDPPorts: PropTypes.arrayOf(PropTypes.number).isRequired,
  inputAudioDevices: PropTypes.arrayOf(audioDevicePropTypes),
  outputAudioDevices: PropTypes.arrayOf(audioDevicePropTypes),
  networkInterfaces: PropTypes.array,
  onSubmit: PropTypes.func.isRequired
};

const PORT_MIN = 1024;
const PORT_MAX = 65535;

class IntercomSettingsForm extends Component {

  constructor(props){
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.toggleInputLink = this.toggleInputLink.bind(this);
    this.toggleOutputLink = this.toggleOutputLink.bind(this);

    this.state = {
      inputLink: false,
      outputLink: false
    };
  }

  handleSubmit(values, { resetForm }){
    const data = { ...values };
    data.inputVolume = JSON.stringify(data.inputVolume);
    data.outputVolume = JSON.stringify(data.outputVolume);
    data.sipRtpPortRange = data.sipRtpPortEnd - data.sipRtpPortStart;
    //if not aes67
    if(isEmptyString(values.aes67NetworkInterface)){
      const { aes67NetworkInterface, ...rest } = data;
      this.props.onSubmit(rest);
    }else{
      this.props.onSubmit(data);
    }
    resetForm(values);
  }

  handleValidation(values){
    const errors = {};

    if(isEmptyString(values.sipRtpPortStart)){
      errors.sipRtpPortStart = 'genericLabel.REQUIRED_FIELD.text';
    } else if (values.sipRtpPortStart < PORT_MIN || values.sipRtpPortStart > PORT_MAX) {
      errors.sipRtpPortStart = 'genericLabel.INVALID_VALUE.text';
    }

    if(isEmptyString(values.sipRtpPortEnd)){
      errors.sipRtpPortEnd = 'genericLabel.REQUIRED_FIELD.text';
    } else if (values.sipRtpPortStart > values.sipRtpPortEnd) {
      errors.sipRtpPortEnd = 'genericLabel.INVALID_VALUE.text';
    } else if (values.sipRtpPortEnd < PORT_MIN || values.sipRtpPortEnd > PORT_MAX) {
      errors.sipRtpPortEnd = 'genericLabel.INVALID_VALUE.text';
    }

    // Forbidden Ports
    if (!errors.sipRtpPortStart && !errors.sipRtpPortEnd) {
      for (const index in this.props.forbiddenUDPPorts) {
        if (this.props.forbiddenUDPPorts[index] >= values.sipRtpPortStart && this.props.forbiddenUDPPorts[index] <= values.sipRtpPortEnd) {
          errors.sipRtpPortStart = 'genericLabel.PORT_ALREADY_USED.text';
          break;
        }
      }
    }
    
    //aes67 
    if(values.aes67Enable){
      if(isEmptyString(values.aes67NetworkInterface)){
        // /errors.aes67NetworkInterface = 'genericLabel.REQUIRED_FIELD.text';
      }
      if(isEmptyString(values.aes67PtpDomain)){
        errors.aes67PtpDomain = 'genericLabel.REQUIRED_FIELD.text';
      }else 
      if(values.aes67PtpDomain<0 || values.aes67PtpDomain>127){
        errors.aes67PtpDomain = 'genericLabel.INVALID_VALUE.text';
      }
    }

    return errors;
  }

  toggleInputLink() {
    this.setState({
      inputLink: !this.state.inputLink
    });
  }

  toggleOutputLink() {
    this.setState({
      outputLink: !this.state.outputLink
    });
  }

  initaes67(){
    const inputDevice = this.props.inputAudioDevices.find(device => device.name === this.props.config.inputDevice) ? this.props.config.inputDevice : '';
    const outputDevice = this.props.outputAudioDevices.find(device => device.name === this.props.config.outputDevice) ? this.props.config.outputDevice : '';
    const selectedInputAudioDevice = inputDevice ? this.props.inputAudioDevices.find(device => device.name === inputDevice) : null;
    const selectedOutputAudioDevice = outputDevice ? this.props.outputAudioDevices.find(device => device.name === outputDevice) : null;
    if (selectedInputAudioDevice && selectedInputAudioDevice.is_aes67){
      return true;
    }else if(selectedOutputAudioDevice && selectedOutputAudioDevice.is_aes67){
      return true;
    }
    return false
  }

  render() {
    const { config, inputAudioDevices, outputAudioDevices, networkInterfaces, hasAES67 } = this.props;
    const sipRtpPortEndDefault = config.sipRtpPortStart + config.sipRtpPortRange
    return (
      <Formik initialValues={{
                autoStart: config.autoStart,
                sipRtpPortStart: config.sipRtpPortStart,
                sipRtpPortRange: config.sipRtpPortRange,
                sipRtpPortEnd: config.sipRtpPortEnd ? config.sipRtpPortEnd : sipRtpPortEndDefault ,
                inputDevice: inputAudioDevices.find(device => device.name === config.inputDevice) ? config.inputDevice : '',
                inputMode: config.inputMode,
                inputVolume: config.inputVolume ? JSON.parse(config.inputVolume) : [],
                outputDevice: outputAudioDevices.find(device => device.name === config.outputDevice) ? config.outputDevice : '',
                outputVolume: config.outputVolume ? JSON.parse(config.outputVolume) : [],
                playbackFramesPerPacket: config.playbackFramesPerPacket,
                aes67NetworkInterface: config.aes67NetworkInterface ? config.aes67NetworkInterface : '',
                nbOutputVisible: config.nbOutputVisible,
                nbInputVisible: config.nbInputVisible,
                aes67Enable: this.initaes67(),
                aes67PtpDomain: config.aes67PtpDomain!==null ? config.aes67PtpDomain : '',
              }}
              validateOnBlur={false}
              validateOnChange={true}
              validate={ this.handleValidation }
              onSubmit={ this.handleSubmit }>
        {({
            values,
            errors,
            dirty,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            handleValidation,
            isSubmitting,
            setFieldValue
            /* and other goodies */
          }) => {
          const selectedInputAudioDevice = values.inputDevice ? inputAudioDevices.find(device => device.name === values.inputDevice) : null;
          const modes = selectedInputAudioDevice && selectedInputAudioDevice.modes ? selectedInputAudioDevice.modes.split(',') : null;
          const selectedOutputAudioDevice = values.outputDevice ? outputAudioDevices.find(device => device.name === values.outputDevice) : null;

          const handleInputDeviceChange = (e) => {
            // When device changes, we update the number of its volume sliders depending on the nb_volume property
            handleChange(e);
            const selectedDeviceName = e.target.value;
            const newVolumeCount = inputAudioDevices.find(device => device.name === selectedDeviceName).nb_volumes;
            setFieldValue('inputVolume',  Array(newVolumeCount).fill(50).map((value, index) => values.inputVolume[index] ? values.inputVolume[index] : value ));
          };
          const handleOutputDeviceChange = (e) => {
            // When device changes, we update the number of its volume sliders depending on the nb_volume property
            handleChange(e);
            const selectedDeviceName = e.target.value;
            const newVolumeCount = outputAudioDevices.find(device => device.name === selectedDeviceName).nb_volumes;
            setFieldValue('outputVolume',  Array(newVolumeCount).fill(50).map((value, index) => values.outputVolume[index] ? values.outputVolume[index] : value ));
          };
          const handleAES67Change = (e) => {
            handleChange(e);
            const selectedInputDevice=inputAudioDevices.find(inputAudioDevice => inputAudioDevice.is_aes67===true)
            let newVolumeCount = selectedInputDevice.nb_volumes;
            setFieldValue('inputVolume',  Array(newVolumeCount).fill(50).map((value, index) => values.inputVolume[index] ? values.inputVolume[index] : value ));

            const selectedOutputDevice=outputAudioDevices.find(outputAudioDevice => outputAudioDevice.is_aes67===true)
            newVolumeCount = selectedOutputDevice.nb_volumes;
            setFieldValue('outputVolume',  Array(newVolumeCount).fill(50).map((value, index) => values.outputVolume[index] ? values.outputVolume[index] : value ));

            setFieldValue('aes67Enable',!values.aes67Enable )

            if(!values.aes67Enable){
              setFieldValue('inputDevice',selectedInputDevice.name);
              setFieldValue('outputDevice',selectedOutputDevice.name);
            }else{
              setFieldValue('inputDevice','');
              setFieldValue('outputDevice','');
            }
          
          }

          const handleInputVolumeChange = (inputLink, index, value) => {
            if (inputLink) {
              for(var i in values.inputVolume){
                setFieldValue(`inputVolume[${i}]`, value)
              }
            }
            else {
              setFieldValue(`inputVolume[${index}]`, value)
            }
          };

          const handleOutputVolumeChange = (outputLink, index, value) => {
            if (outputLink) {
              for(var i in values.outputVolume){
                setFieldValue(`outputVolume[${i}]`, value)
              }
            }
            else {
              setFieldValue(`outputVolume[${index}]`, value)
            }
          };

          if (values.inputVolume.length === 0 && selectedInputAudioDevice && selectedInputAudioDevice.nb_volumes>0){
            var inputVolume = [];
            for (let index = 0; index < selectedInputAudioDevice.nb_volumes; index++) {
              inputVolume.push(50)
            }
            setFieldValue("inputVolume",inputVolume)
          }
          if (values.outputVolume.length === 0 && selectedOutputAudioDevice && selectedOutputAudioDevice.nb_volumes>0){
            var outputVolume = [];
            for (let index = 0; index < selectedOutputAudioDevice.nb_volumes; index++) {
              outputVolume.push(50)
            }
            setFieldValue("outputVolume",outputVolume)
          }

          return (
          <Form onSubmit={handleSubmit}>
            <FormGroup check>
              <Label check>
                <Input id="intercomSettings_autoStart"
                       type="checkbox"
                       name="autoStart"
                       onChange={handleChange}
                       checked={values.autoStart}/>{' '}
                <Translate id="genericLabel.ENABLE_INTERCOM_AUTO_START.text"/>
              </Label>
            </FormGroup>
            <FormGroup>
              <Label for="sipRtpPortStart">
                <Translate id="genericLabel.UDP_PORT_RANGE.text"/>
              </Label>
              { (config.sipRtpPortStart !== values.sipRtpPortStart || config.sipRtpPortEnd !== values.sipRtpPortEnd) && dirty &&
              <Alert color="warning">
                <Translate id="genericLabel.RESTART_STREAMHUB_TO_TAKE_CHANGES_INTO_ACCOUNT.text"/>
              </Alert>
              }
              <div className="row mr-1">
                <div className="col-md-3">
                <Input type="number"
                       name="sipRtpPortStart"
                       id="intercomSettings_sipRtpPortStart"
                       min={PORT_MIN}
                       max={PORT_MAX}
                       invalid={errors.sipRtpPortStart !== undefined}
                       value={values.sipRtpPortStart}
                       onChange={handleChange}/>
                <FormFeedback>
                  <Translate id={errors.sipRtpPortStart}/>
                </FormFeedback>
                </div>
                <div className="col-md-3">
                <Input type="number"
                       name="sipRtpPortEnd"
                       id="intercomSettings_sipRtpPortEnd"
                       min={PORT_MIN}
                       max={PORT_MAX}
                       invalid={errors.sipRtpPortEnd !== undefined}
                       value={values.sipRtpPortEnd}
                       onChange={handleChange}/>
                <FormFeedback>
                  <Translate id={errors.sipRtpPortEnd}/>
                </FormFeedback>
                </div>
              </div>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input id="intercomSettings_aes67Enable"
                      type="checkbox"
                      name="autoStaaes67Enablert"
                      onChange={handleAES67Change}
                      disabled={!hasAES67}
                      checked={values.aes67Enable}/>{' '}
                {"Enable AES-67"/* <Translate id="genericLabel.ENABLE_INTERCOM_AUTO_START.text"/> */}
              </Label>
            </FormGroup>
            <Row form>
              <Col>
                {!values.aes67Enable && <FormGroup>
                  <Label for="inputDevice">
                    <Translate id="genericLabel.INPUT_DEVICE.text"/>
                  </Label>
                  <Input type="select"
                        name="inputDevice"
                        id="intercomSettings_inputDevice"
                        value={values.inputDevice}
                        onChange={handleInputDeviceChange}>
                    { !selectedInputAudioDevice  &&
                        <option value=''></option>
                    }
                    { inputAudioDevices.map(device => (<>
                      {!device.is_aes67 && <option key={device.name} value={device.name}>{ device.name }</option>}</>
                    ))}
                  </Input>
                </FormGroup>}
              </Col>
              { modes &&
              <Col>
                <FormGroup>
                  <Label for="inputMode">
                    <Translate id="genericLabel.MODE.text"/>
                  </Label>
                  <Input type="select"
                        name="inputMode"
                        id="intercomSettings_inputMode"
                        value={values.inputMode}
                        onChange={handleChange}>
                    { modes.map(mode => (
                      <option key={mode} value={mode}>{mode}</option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              }
            </Row>
            { selectedInputAudioDevice && values.inputVolume.length > 0 &&
            <FormGroup>
              <Label for="inputVolume">
                <Translate id="genericLabel.VOLUME.text"/>
              </Label>
              <div id="intercomSettings_inputVolume">
                {values.inputVolume.map((volume, index) => (
                  <VolumeSlider key={`i${index + 1}`}
                                name={`i${index + 1}`}
                                onChange={value => handleInputVolumeChange(this.state.inputLink, index, value)}
                                value={volume}/>
                ))}
              </div>
            </FormGroup>
            }
            { selectedInputAudioDevice && values.inputVolume.length > 0 &&
            <FormGroup check>
              <Label check>
                <Input id="intercomSettings_inputLink"
                       type="checkbox"
                       name="inputLink"
                       onChange={e => { this.toggleInputLink(); handleInputVolumeChange(!this.state.inputLink, 0, values.inputVolume[0])}}
                       checked={this.state.inputLink}/>{' '}
                <Translate id="genericLabel.SAME_LEVELS.text"/>
              </Label>
            </FormGroup>
            }
            {!values.aes67Enable && <FormGroup>
              <Label for="outputDevice">
                <Translate id="genericLabel.OUTPUT_DEVICE.text"/>
              </Label>
              <Input type="select"
                     name="outputDevice"
                     id="intercomSettings_outputDevice"
                     value={values.outputDevice}
                     onChange={handleOutputDeviceChange}>
                { !selectedOutputAudioDevice &&
                     <option value=''></option>
                }
                { outputAudioDevices && outputAudioDevices.map(device => (<>
                      {!device.is_aes67 && <option key={device.name} value={device.name}>{ device.name }</option>}</>
                ))}
              </Input>
            </FormGroup>}
            { selectedOutputAudioDevice && values.outputVolume.length > 0 &&
            <FormGroup>
              <Label for="outputVolume">
                <Translate id="genericLabel.VOLUME.text"/>
              </Label>
              <div id="intercomSettings_outputVolume">
                {values.outputVolume.map((volume, index) => (
                  <VolumeSlider key={`o${index + 1}`}
                                name={`o${index + 1}`}
                                onChange={value => handleOutputVolumeChange(this.state.outputLink, index, value)}
                                value={volume}/>
                ))}
              </div>
            </FormGroup>
            }
            { selectedOutputAudioDevice && values.outputVolume.length > 0 &&
            <FormGroup check>
              <Label check>
                <Input id="intercomSettings_outputLink"
                       type="checkbox"
                       name="outputLink"
                       onChange={e => { this.toggleOutputLink(); handleOutputVolumeChange(!this.state.outputLink, 0, values.outputVolume[0])}}
                       checked={this.state.outputLink}/>{' '}
                <Translate id="genericLabel.SAME_LEVELS.text"/>
              </Label>
            </FormGroup>
            }
            { values.aes67Enable &&
              <FormGroup>
                <div className="header">
                  <div className="title secondary">
                    AES-67
                  </div>
                </div>
                <Label for="aes67PtpDomain">
                  PTP Domain Number
                </Label>
                <Input type="number"
                       name="aes67PtpDomain"
                       id="intercomSettings_aes67PtpDomain"
                       min={0}
                       max={127}
                       invalid={errors.aes67PtpDomain !== undefined}
                       value={values.aes67PtpDomain}
                       onChange={handleChange}/>
                <FormFeedback>
                  <Translate id={errors.aes67PtpDomain}/>
                </FormFeedback>
                <Label for="aes67NetworkInterface">
                  Network Interface
                </Label>
                <Input type="select"
                      name="aes67NetworkInterface"
                      id="AES67Settings_inputMode"
                      value={values.aes67NetworkInterface}
                      invalid={errors.aes67NetworkInterface !== undefined}
                      onChange={handleChange}>
                        <option value=''></option>
                        {networkInterfaces && networkInterfaces.map((value, index)=>(
                          <option key={value.itf_name} value={value.itf_name} id={value.ipAddress}>{value.ipAddress}</option>
                        ))}
                </Input>
                <FormFeedback>
                  <Translate id={errors.aes67NetworkInterface}/>
                </FormFeedback>
              </FormGroup>
            }
            <FormGroup className="buttons">
              <Button id="intercomSettings_submit"
                      color="primary"
                      disabled={isSubmitting || !dirty}
                      type="submit">
                <Translate id="genericLabel.SAVE.text"/>
              </Button>
            </FormGroup>
          </Form>
        )}}
      </Formik>
    );
  }
}

IntercomSettingsForm.propTypes = propTypes;

export default IntercomSettingsForm;
